import { IScope, IWindowService } from "angular";
import { BlockConfigurationObject } from "../../interfaces/block-configuration-object.interface";
// import { MatchService } from "../../services/match.service";
import { SportDataService } from "../../services/sport-data.service";

// import { parseJSON } from "date-fns";
import { GeneralService } from "../../services/general.service";
// import { BetService } from "../../services/bet.service";
// import { Match } from "../../interfaces/match.interface";


export class SingleOfferBannerController {
	
	// awayBeforeHome = false;
	// bestBetError = false;
	// bestParlayUnavailable = false;
	// betService: BetService;
	// betType: string;
	displayMaximumWidths = {
		"x-compact": 350,
		"compact": 500,
		"less-compact": 600,
		"medium": 700,
		"large": 800,
	};
	displayMode = "full";
	// gamesError = false;
	// gamesLoading = true;
	generalService: GeneralService;
	// match: Match = null;
	// showBestParlay = false;
	_$scope: IScope;
	// _Rollbar: any;
	_$window: IWindowService;
	configurationObject: BlockConfigurationObject;
	// matchService: MatchService;
	sportDataService: SportDataService;
	// bannerLoading = true;
	// bannerError = false;

	// betString = "";
	// oddsString = "";
	// desktopButtonString = "";
	// mobileButtonString = "";

	promoData: {
		bookmakerLogoBgColor: string
		bookmakerLogoURL: string
		offerTag1Text: string
		offerTag1BgColor: string
		offerTag1TextColor: string
		offerTag2Text: string
		offerTag2BgColor: string
		offerTag2TextColor: string
		promoText: string
		promoLinkURL: string
		buttonText: string
		promosStepsList?: Array<string>
		promosStepsParagraph?: string,
		promosDisclaimer: string
	} = null;

	promoLoading = true;
	promoError = false;

    offerDropdownOpen = false;

	/* @ngInject */
	constructor(
		$scope: IScope, 
		// Rollbar: any, 
		$window: IWindowService, 
		configurationObject: BlockConfigurationObject,
		generalService: GeneralService,
		sportDataService: SportDataService,
		){
		this._$scope = $scope;
		// this._Rollbar = Rollbar;
		this._$window = $window;
		this.configurationObject = configurationObject;
		// this.matchService = matchService;
		this.sportDataService = sportDataService;
		this.generalService = generalService;
		// this.betService = betService;

		// this.betType = configurationObject.betType;


		
		generalService.initialiseBlock();


		Object.keys(this.displayMaximumWidths).forEach(level => {
			if ($window.document.getElementById(configurationObject.targetElementID)
				&& $window.document.getElementById(configurationObject.targetElementID).offsetWidth <= this.displayMaximumWidths[level]) {
				this.displayMode += ` ${level}`;
			}
		});

		$window.addEventListener("resize", this.checkCompact);

		this.getPromo();
	}

	checkCompact = (): void => {
		let modeString = "full";
		Object.keys(this.displayMaximumWidths).forEach(level => {
			if (this._$window.document.getElementById(this.configurationObject.targetElementID)
				&& this._$window.document.getElementById(this.configurationObject.targetElementID).offsetWidth <= this.displayMaximumWidths[level]) {
				modeString += ` ${level}`;
			}
		});

		this._$scope.$apply(() => {
			this.displayMode = modeString;
		});
	}

	getPromo = (): void => {
		if (this.configurationObject.promoID) {
			this.sportDataService.getPromoFromCosmic(this.configurationObject.promoID)
				.then(promo => {
					this.promoData = {
						bookmakerLogoBgColor: promo.metadata.sportsbook[0].metadata.hex_color,
						bookmakerLogoURL: promo.metadata.sportsbook[0].metadata.dark_bg_logo.imgix_url,
						offerTag1Text: promo.metadata.tags?.[0]?.metadata.text,
						offerTag1BgColor: promo.metadata.tags?.[0]?.metadata.bg_hex_color,
						offerTag1TextColor: promo.metadata.tags?.[0]?.metadata.text_hex_color,
						offerTag2Text: promo.metadata.tags?.[1]?.metadata.text,
						offerTag2BgColor: promo.metadata.tags?.[1]?.metadata.bg_hex_color,
						offerTag2TextColor: promo.metadata.tags?.[1]?.metadata.text_hex_color,
						promoText: promo.metadata.promos_title,
						promoLinkURL: promo.metadata.promos_link,
						buttonText: promo.metadata.promos_button_text,
						promosStepsParagraph: promo.metadata.promos_steps,
						promosDisclaimer: promo.metadata.promos_disclaimer,

					};
					this.promoLoading = false;
				}).catch(() => {
					this.promoError = true;
				});
		} else {
			this.promoData = {
				bookmakerLogoBgColor: this.configurationObject.bookmakerLogoBgColor,
				bookmakerLogoURL: this.configurationObject.bookmakerLogoURL,
				offerTag1Text: this.configurationObject.offerTag1Text,
				offerTag1BgColor: this.configurationObject.offerTag1BgColor,
				offerTag1TextColor: this.configurationObject.offerTag1TextColor,
				offerTag2Text: this.configurationObject.offerTag2Text,
				offerTag2BgColor: this.configurationObject.offerTag2BgColor,
				offerTag2TextColor: this.configurationObject.offerTag2TextColor,
				promoText: this.configurationObject.promoText,
				promoLinkURL: this.configurationObject.promoLinkURL,
				buttonText: this.configurationObject.buttonText,
				promosStepsList: this.configurationObject.promosSteps,
				promosDisclaimer: this.configurationObject.promosDisclaimer,

			};
			this.promoLoading = false;
		}
	}

	toggleOfferDropdown = (event): void => {
		event.stopPropagation();
		this.offerDropdownOpen = !this.offerDropdownOpen;
	}

	redirectOffer = (url: string): void =>{
		window.open(url, "_blank");
	}

}